export const types = {
  MODAL_HIDE: 'MODAL_HIDE',
  MODAL_SHOW: 'MODAL_SHOW'
};

export const modalHide = () => ({
  type: types.MODAL_HIDE
});

export const showModal = () => ({
  type: types.MODAL_SHOW
});



// WEBPACK FOOTER //
// ./src/store/actions/modal.js